const { formatMoney } = window.BAO.Utils
class AddCharms extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleOptionChange = this.handleOptionChange.bind(this)

    this.els.option?.elements.forEach((optionEl) => {
      this.listeners.add(optionEl, 'change', this.handleOptionChange)
    })

    this.addToCart = this.addToCart.bind(this)
    this.listeners.add(window, 'productAddedToCart', this.addToCart)
  }

  handleOptionChange (event) {
    const optionEl = event.target

    this.els.option?.elements.forEach((allOptionEl) => {
      if (optionEl !== allOptionEl) {
        allOptionEl.checked = false
      }
    })

    if (optionEl.checked) {
      const productId = optionEl.getAttribute('data-add-charms-product-id')
      const variantId = optionEl.getAttribute('data-add-charms-variant-id')
      const optionPrice = optionEl.getAttribute('data-add-charms-price')
      const optionTitle = optionEl.getAttribute('data-title')
      const optionName = optionEl.getAttribute('data-name')

      this.els.formVariantId.element.value = variantId
      this.els.formLastSelectedProductId.element.value = productId
      this.els.formProductId.element.value = productId

      if (this.isQuickBuy) {
        this.handleQuickBuyOptionSelect(optionTitle)
      } else {
        this.handleDefaultOptionSelect(optionPrice, productId, optionName)
      }
    } else {
      this.els.formVariantId.element.value = ''
      this.els.formLastSelectedProductId.element.value = ''
      this.els.formProductId.element.value = ''

      if (this.isQuickBuy) {
        this.unselectOptionQuickBuy()
      } else {
        this.unselectOptionProductForm()
      }
    }
  }

  unselectOptionQuickBuy () {
    window.drawers.activeDrawerKey = 'drawer-quick-buy'

    const selectedTextEl = document.querySelector(
      this.quickBuySelectedTextSelector,
    )

    if (selectedTextEl) {
      selectedTextEl.textContent = selectedTextEl.getAttribute('data-text')
      selectedTextEl.classList.add(this.inputUnselectedClass)
    }
  }

  unselectOptionProductForm () {
    setTimeout(() => {
      document.querySelector('site-drawers')?.closeDrawer()
    }, 300)

    const selectedPriceEl = document.querySelector(
      this.productFormSelectedPriceSelector,
    )

    if (selectedPriceEl) {
      selectedPriceEl.textContent = ''
    }

    const selectedTitleEl = document.querySelector(
      this.productFormSelectedTextSelector,
    )

    if (selectedTitleEl) {
      selectedTitleEl.textContent = selectedTitleEl.getAttribute('data-text')
      selectedTitleEl.classList.remove(this.productFormSelectedClass)
    }

    if (this.externalEls['product-form-image-input']) {
      this.externalEls['product-form-image-input'].elements.forEach(
        (element) => {
          element.value = ''
        },
      )
    }

    this.updatePrice(0)
  }

  handleDefaultOptionSelect (optionPrice, productId, optionName) {
    setTimeout(() => {
      document.querySelector('site-drawers')?.closeDrawer()
    }, 300)

    const selectedPriceEl = document.querySelector(
      this.productFormSelectedPriceSelector,
    )

    if (selectedPriceEl) {
      selectedPriceEl.textContent = `+${formatMoney(optionPrice)}`
    }

    const selectedTitleEl = document.querySelector(
      this.productFormSelectedTextSelector,
    )

    if (selectedTitleEl) {
      selectedTitleEl.textContent = optionName
      selectedTitleEl.classList.add(this.productFormSelectedClass)
    }

    this.updateMedia(productId)
    this.updatePrice(optionPrice)
  }

  handleQuickBuyOptionSelect (optionTitle) {
    window.drawers.activeDrawerKey = 'drawer-quick-buy'

    const selectedTextEl = document.querySelector(
      this.quickBuySelectedTextSelector,
    )

    if (selectedTextEl) {
      selectedTextEl.textContent = optionTitle
      selectedTextEl.classList.remove(this.inputUnselectedClass)
    }
  }

  updateMedia (productId) {
    const imageEl = document.querySelector(
      `[data-add-charms-external-el="product-image"][data-charm="${productId}"]`,
    )

    if (this.externalEls['product-form-image-input']) {
      this.externalEls['product-form-image-input'].elements.forEach(
        (element) => {
          element.value = imageEl?.dataset.image ?? ''
        },
      )
    }

    const mediaEl = document.querySelector('product-media')

    if (mediaEl && imageEl) {
      mediaEl.moveToIdx(imageEl.dataset.index)
    }
  }

  updatePrice (optionPrice) {
    this.externalEls.price?.elements.forEach((priceEl) => {
      const currentPrice = parseInt(priceEl.dataset.price)
      const combinedPrice = currentPrice + parseInt(optionPrice)

      priceEl.setAttribute('data-add-charms-price', optionPrice)
      priceEl.textContent = formatMoney(combinedPrice)
    })

    this.externalEls.personalisationPrice?.elements.forEach((element) => {
      element.setAttribute('data-add-hoops-price', optionPrice)
    })
  }

  addToCart (event) {
    const formId = event?.detail?.formId

    if (formId !== this.dataset.formId) return

    const variantId = this.els.formVariantId.element.value

    this.els.formParentKey.element.value = event.detail.item.key

    // Only add charms to cart if a charm variant has been selected
    if (!variantId || variantId === '') {
      return Promise.resolve()
    }

    return window.BAO.Cart.addItemFromForm(this.els.form.element)
  }

  get isQuickBuy () {
    return this.dataset.context === 'quick-buy'
  }

  get inputUnselectedClass () {
    return `qb-Form_VariantText-light`
  }

  get quickBuySelectedTextSelector () {
    return `[data-product-charms-external-el="quickbuy-selected-text"]`
  }

  get productFormSelectedTextSelector () {
    return `[data-product-charms-external-el="product-form-selected-text"]`
  }

  get productFormSelectedPriceSelector () {
    return `[data-product-charms-external-el="product-form-selected-price"]`
  }

  get productFormSelectedClass () {
    return `prd-Form_VariantText-dark`
  }
}

if (!customElements.get('add-charms')) {
  customElements.define('add-charms', AddCharms)
}
